import React from 'react';
import TopNavigation from './TopNavigation';

interface LoginRequiredStateProps {
  isDarkMode: boolean;
  onToggleMenu: () => void;
  onNavigateHome?: () => void;
  onNavigateToLogin?: (source?: string) => void;
  onNavigateToSignup?: (source?: string) => void;
  isLoading?: boolean;
  message?: string;
}

const LoginRequiredState: React.FC<LoginRequiredStateProps> = ({
  isDarkMode,
  onToggleMenu,
  onNavigateHome,
  onNavigateToLogin,
  onNavigateToSignup,
  isLoading,
  message = "Please log in to view your profile"
}) => {
  const themeClasses = isDarkMode ? 'text-white' : 'bg-white text-gray-900';

  return (
    <div
      className={`min-h-screen ${themeClasses} transition-colors duration-300`}
      style={{
        backgroundColor: isDarkMode
          ? 'var(--background-colour-dark-mode)'
          : 'var(--background-colour-light-mode)'
      }}
    >
      <TopNavigation
        isDarkMode={isDarkMode}
        onToggleMenu={onToggleMenu}
        onNavigateHome={onNavigateHome}
        onNavigateToLogin={(source) => onNavigateToLogin?.(source)}
        onNavigateToSignup={(source) => onNavigateToSignup?.(source)}
        isLoading={isLoading}
      />

      {/* Full screen container */}
      <div className="w-full h-screen">
        {/* Top 1/3 of the screen */}
        <div className="h-1/3 flex items-center justify-center p-8">
          <div className="text-center">
            <h1 className="text-lg xs:text-xl xs:text-2xl font-medium mb-6">{message}</h1>
            <button
              onClick={() => onNavigateToLogin?.()}
              className={`py-1.5 2xs:py-2 px-3 2xs:px-4 text-sm font-white font-medium whitespace-nowrap rounded-full border transition-colors cursor-pointer ${
                isDarkMode
                  ? 'border-blue-400 text-blue-400 hover:bg-blue-900/20'
                  : 'border-blue-600 text-blue-600 hover:bg-blue-50'
              }`}
            >
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredState;